import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { flatten, uniq, values } from "lodash";
import { Loader } from "semantic-ui-react";

import { ManagerFeedbackOnReportQuestionnaire } from "@teamprevent/common/managerFeedbackOnReport/components/ManagerFeedbackOnReportQuestionnaire";
import {
    ManagerFeedbackOnReportQuestionnaireModel,
    MANAGER_FEEDBACK_ON_REPORT_KEY,
    ParentConsultationModel
} from "@teamprevent/common/managerFeedbackOnReport/models";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";

import { ApplicationState } from "../../applicationState";
import { managerFeedbackOnReportApi } from "../managerFeedbackOnReportApi";
import { loadManagerFeedbackOnReportQuestionnaire } from "../actions";

export const ManagerFeedbackOnReportForm: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const [parentConsultation, setParentConsultation] = React.useState<ParentConsultationModel>(null);

    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const taskId = useSelector((state: ApplicationState) => state.router.params?.taskId);
    const ohCase = useSelector((state: ApplicationState) => state.ohCases.find(c => c.id === ohCaseId));
    const task = ohCase?.tasks?.find(t => t.id === taskId);

    const stateQuestionnaire = useSelector((state: ApplicationState) => state.questionnaires[MANAGER_FEEDBACK_ON_REPORT_KEY]);
    const questions: AnsweredQuestionWithId[] = uniq(flatten(stateQuestionnaire?.sections?.map(section => values(section.questions))));
    const eTag = stateQuestionnaire?.eTag;
    const feedbackQuestionnaire: ManagerFeedbackOnReportQuestionnaireModel = { questions, eTag };

    React.useEffect(() => {
        (async () => {
            if (customerId && ohCaseId && taskId) {
                const data = await managerFeedbackOnReportApi.getConsultationData(customerId, ohCaseId, taskId);
                setParentConsultation(data);
            }
        })();
    }, [ohCaseId, taskId]);

    const load = async () => {
        dispatch(loadManagerFeedbackOnReportQuestionnaire(customerId, ohCaseId, taskId));
    };

    if (ohCase && task && parentConsultation) {
        return (
            <ManagerFeedbackOnReportQuestionnaire
                customerId={customerId}
                ohCase={ohCase}
                task={task}
                parentConsultation={parentConsultation}
                loadQuestionnaire={load}
                questionnaire={feedbackQuestionnaire}
            />
        );
    }

    return <Loader active />;
};
